/**
 * Main - No bloat please!
 *
 * Performs necessary DOM modifications at the earliest opportunity.
 *
 * Do not defer or load async! It's meant to fire ASAP.
 *
 * Read this file from the bottom up for best results.
 *
 */
// todo: most of this JS is pretty oldschool, was adapted lazily from previous base theme versions that did not have a great webpack setup. Now we can use proper imports and modules and whatnot.
//  furthermore, even this file is not up-to-date with more recent versions in child themes. You'll be overwriting this file in the child 100% of the time anyway, though.

// todo: import bootstrap js modules selectively as needed instead of the bundle.
import "bootstrap/dist/js/bootstrap.bundle.min.js";

( function ( baseTheme ) {
	'use strict';

	/**
	 * Standard debounce
	 *
	 * @param {number} milliseconds
	 * @param {Object} debouncedFunction
	 */
	baseTheme.debounce = ( milliseconds, debouncedFunction ) => {
		let clock;
		return function () {
			clearTimeout( clock );
			const debouncedArguments = Array.prototype.slice.call( arguments );
			debouncedArguments.unshift( this );
			clock = setTimeout( debouncedFunction.bind.apply( debouncedFunction, debouncedArguments ), milliseconds );
		};
	};

	baseTheme.setDynamicSizeCssProperties = () => {
		baseTheme.calcScrollbarSize();

		if ( null !== document.querySelector( '.header-primary' ) ) {
			baseTheme.calcHeaderHeight();
		}
	};

	baseTheme.setRootCssProperty = ( name, value ) => {
		document.documentElement.style.setProperty( '--' + name, value );
	};

	/**
	 * Calculate scrollbar size - necessary to prevent horizontal overflow when using 100vw ...on Windows... of course.
	 * Saves the width of the scrollbar offset to the css property --scrollbar-width. Should be 0 on sane systems.
	 */
	baseTheme.calcScrollbarSize = () => {
		if ( window.innerWidth > document.body.clientWidth ) {
			document.body.classList.add( 'has-scrollbar' );
			baseTheme.setRootCssProperty( 'scrollbar-width', ( window.innerWidth - document.body.clientWidth ) + 'px' );
		} else {
			baseTheme.setRootCssProperty( 'scrollbar-width', '0px' );
		}
	};


	/**
	 * Calculate Header Height.
	 * Saves the height of the first detected <header> element to the CSS property "--header-height".
	 */
	baseTheme.calcHeaderHeight = () => {
		const header = document.querySelector( '.header-primary' );
		baseTheme.setRootCssProperty( 'header-height', ( header.offsetHeight + header.offsetTop ) + 'px' );
	};

	baseTheme.setBodyJsActive = () => {
		document.body.classList.remove( 'no-js' );
		document.body.classList.add( 'js-ok' );
	};

	baseTheme.linkIconsInit = () => {
		const links = document.querySelectorAll( 'main a' );

		links.forEach( function ( link ) {
			link.pdf = link.hasAttribute( 'href' ) ? link.getAttribute( 'href' ).includes( '.pdf' ) : false;
			link.newWindow = link.hasAttribute( 'target' ) ? link.getAttribute( 'target' ).includes( '_blank' ) : false;

			if ( link.pdf ) {
				const iconPdfLink = document.createElement( 'span' );
				iconPdfLink.classList.add( 'is-style-link-pdf' );
				link.appendChild( iconPdfLink );
			}

			if ( link.newWindow && !link.pdf ) {
				const iconExternalLink = document.createElement( 'span' );
				iconExternalLink.classList.add( 'is-style-link-external' );
				link.appendChild( iconExternalLink );
			}
		} );
	};

	baseTheme.onBodyResize = new ResizeObserver( baseTheme.debounce( 50, function () {
		baseTheme.calcScrollbarSize();
	} ) );

	baseTheme.onHeaderResize = new ResizeObserver( () => {
		baseTheme.calcHeaderHeight();
	} );

	baseTheme.maybeLoadMegas = () => {

		const megas = document.querySelectorAll( '.megamenu' );
		if ( 0 !== megas.length ) {
			baseTheme.megas = import( './modules/megamenu.js' )
				.then( ( { default: MegaMenu } ) => {
					megas.forEach( function ( mega ) {
						return new MegaMenu( mega );
					} );
				} );
		}
	};

	baseTheme.previousSiblings = ( el ) => {
		const siblings = [];
		while ( el.previousElementSibling ) {
			el = el.previousElementSibling;
			siblings.push( el );
		}
		return siblings;
	};

	/**
	 * Initialize all after DCL happens.
	 */
	window.addEventListener( 'DOMContentLoaded', () => {
		baseTheme.setBodyJsActive();
		baseTheme.setDynamicSizeCssProperties();
		baseTheme.linkIconsInit();
	}, { once: true } );
	/**
	 *
	 * Initialize all after load happens (meaning, after all important scripts and styles).
	 */

	window.addEventListener( 'load', () => {
		baseTheme.onBodyResize.observe( document.querySelector( 'body' ) );
		if ( null !== document.querySelector( '.header-primary' ) ) {
			baseTheme.onHeaderResize.observe( document.querySelector( '.header-primary' ) );
		}
		baseTheme.maybeLoadMegas();

	}, { once: true } );

	return baseTheme;
}( window.baseTheme = window.baseTheme || {} ) );
